import React from 'react'
import AnimatePage from '../components/AnimatePage'
import Wrapper from '../helpers/Wrapper'
import img from '../assets/images/shopimage.jpg'
import { ChangePageTitle } from '../helpers/ChangeTitle'

function About() {

    ChangePageTitle("About")

    return (
        <div className='w-full relative'>
            <AnimatePage>
                <Wrapper>
                    <div className="w-full relative mt-20">
                        {/* Head of  About us page */}
                        <div className="w-full text-center space-y-7">
                            <h5 className="text-xs uppercase tracking-wide text-slate-800 font-semibold">
                                welcome to ecoshoppe
                            </h5>

                            <div className="space-y-3">
                                <h4 className="text-center text-3xl sm:text-4xl lg:text-[45px] mx-auto">
                                    Eco Store
                                </h4>
                                <h4 className="text-center text-3xl sm:text-4xl lg:text-[45px] mx-auto">
                                    Available to Everyone!
                                </h4>
                            </div>

                            <p className="text-gray-600 text-center text-[clamp(1rem,2vw+1rem,1.05rem)] tracking-wide mx-auto max-w-[900px] leading-relaxed">
                                Over 20 years of experience, we have meticulously curated collections that
                                transcend fleeting trends, embodying a timeless elegance that resonates with our discerning clientele.
                            </p>

                            {/* Image */}
                            <div className="flex justify-center items-center mx-auto">
                                <div className="relative overflow-hidden">
                                    <img src={img} alt="" className='w-full rounded-2xl' />
                                </div>
                            </div>

                            {/* Happy About Us */}
                            <div className="flex justify-between items-center">

                            </div>

                            <p className="text-gray-600 text-center text-[clamp(1rem,2vw+1rem,1.05rem)] tracking-wide mx-auto max-w-[900px] leading-relaxed">
                                At Ecoshoppe, we believe in making sustainable choices easy and accessible for everyone.
                                We provide eco-friendly products that are both high-quality and affordable, helping you to live a greener,
                                more responsible lifestyle without compromising on style or convenience. Our mission is to foster a community
                                dedicated to environmental consciousness and positive change, one product at a time.
                            </p>
                        </div>
                    </div>
                </Wrapper>
            </AnimatePage>
        </div>
    )
}

export default About